<template>
  <div class="wrapper">
    <div class="fivthWrapper" v-if="!isIpad">
      <div class="top">
        <router-link
          class="top-row"
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          v-for="(item, index) in list.slice(0, 1)"
          :key="index"
        >
          <ImageContainer
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
            class="img"
          />
          <div class="content">
            <h2>{{ item.sub_category.name }}</h2>
            <h1>{{ item.title }}</h1>
            <h3>
              {{ handleDate(item.pub_date) }},
              {{ handleTime(item.pub_date) }}
            </h3>
            <p>{{ item.brief }}</p>
          </div>
        </router-link>
      </div>
      <div class="mid">
        <router-link
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          class="mid-left"
          v-for="(item, index) in list.slice(1, 2)"
          :key="index"
        >
          <ImageContainer
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
            class="img"
          />
          <div class="content">
            <h2>{{ item.sub_category.name }}</h2>
            <h1>{{ item.title }}</h1>
            <h3>
              {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
            </h3>
          </div>
        </router-link>
        <div class="mid-right">
          <template v-for="(item, index) in list.slice(2, 5)" :key="index">
            <router-link
              :to="
                $i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })
              "
              class="mid-right-row"
            >
              <div class="img-holder">
                <ImageContainer
                  :src="item.image.medium"
                  :thumb="item.image.thumbnail"
                  :alt="item.title"
                  class="img"
                />
              </div>
              <div class="content">
                <h2>{{ item.sub_category.name }}</h2>
                <h1>{{ item.title }}</h1>
                <h3>
                  {{ handleDate(item.pub_date) }},
                  {{ handleTime(item.pub_date) }}
                </h3>
              </div>
            </router-link>
          </template>
        </div>
      </div>
      <div class="right">
        <template v-for="(item, index) in list.slice(5, 8)" :key="index">
          <router-link
            :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
            class="right-page"
          >
            <ImageContainer
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
              class="img"
            />
            <div class="content">
              <h2>{{ item.sub_category.name }}</h2>
              <h3>
                {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
              </h3>
              <h1>{{ item.title }}</h1>
            </div>
          </router-link>
        </template>
      </div>
    </div>
    <div class="fivthIpad" v-if="isIpad">
      <div class="ipad-top">
        <template v-for="(item, index) in list.slice(0, 1)" :key="index">
          <router-link to="">
            <div class="ipad-top-holder">
              <ImageContainer
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
                class="img"
              />
              <div class="ipad-content">
                <h1>{{ item.title }}</h1>
                <h2>{{ item.sub_category.name }}</h2>
                <h3>
                  {{ handleDate(item.pub_date) }},
                  {{ handleTime(item.pub_date) }}
                </h3>
                <p>{{ item.brief }}</p>
              </div>
            </div>
          </router-link>
        </template>
      </div>
      <div class="bottom">
        <div class="left-column">
          <template v-for="(item, index) in list.slice(1, 3)" :key="index">
            <router-link
              :to="
                $i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })
              "
              class="ipad-left"
            >
              <ImageContainer
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
                class="img"
              />
              <div class="ipad-content">
                <h2>{{ item.sub_category.name }}</h2>
                <h1>{{ item.title }}</h1>
                <h3>
                  {{ handleDate(item.pub_date) }},
                  {{ handleTime(item.pub_date) }}
                </h3>
              </div>
            </router-link>
          </template>
        </div>
        <div class="right-column">
          <template v-for="(item, index) in list.slice(3, 8)" :key="index">
            <router-link
              :to="
                $i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })
              "
              class="rightsec"
            >
              <ImageContainer
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
                class="img"
              />
              <div class="ipad-content">
                <h2>{{ item.sub_category.name }}</h2>
                <h1>{{ item.title }}</h1>
                <h3>
                  {{ handleDate(item.pub_date) }},
                  {{ handleTime(item.pub_date) }}
                </h3>
              </div>
            </router-link>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const isIpad = ref();

    const handleResize = () => {
      isIpad.value = window.innerWidth <= 1366;
    };

    if (typeof window !== "undefined") {
      isIpad.value = window.innerWidth <= 1366;
      window.addEventListener("resize", handleResize);
    }

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    });

    return {
      ...useFormatter(),
      isIpad,
    };
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .fivthWrapper {
    background: var(--second-bg);
    display: grid;
    grid-template-areas:
      "top right"
      "mid right";
    padding-bottom: 7.656vw;
    h1 {
      font-size: 1.25vw;
      padding: 0 1.5vw;
      line-height: 1.667vw;
    }
    p {
      font-size: 0.938vw;
      line-height: 1.25vw;
      display: block; /* Fallback for non-webkit */
      display: -webkit-box;
      -webkit-line-clamp: 3; /* if you change this, make sure to change the fallback line-height and height */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 3.606vw;
    }
    h2 {
      font-size: 0.833vw;
      line-height: 1.042vw;
    }
    h3 {
      font-size: 0.833vw;
      line-height: 1.042vw;
      color: var(--date-grey);
    }
    .top {
      grid-area: top;
      padding-top: 2.344vw;
      padding-bottom: 2.344vw;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      width: 76.302vw;
      height: 30.729vw;
      margin-top: 5.573vw;
      background: white;
      color: black;
      .top-row {
        display: flex;
        .img {
          width: 20.833vw;
          height: 15.625vw;
          margin-left: 2.344vw;
        }
        .content {
          width: 31.688vw;
          margin-left: 1.823vw;
          display: grid;
          grid-template-areas:
            "top-title top-title"
            "top-category top-date"
            "top-brief top-brief"
            "top-brief top-brief"
            "top-brief top-brief"
            "top-brief top-brief"
            "top-brief top-brief"
            "top-brief top-brief";
          h1 {
            grid-area: top-title;
            font-weight: 700;
            padding: 0;
          }
          h2 {
            grid-area: top-category;
            font-weight: 400;
          }
          h3 {
            grid-area: top-date;
            font-weight: 400;
          }
          p {
            grid-area: top-brief;
            font-weight: 500;
          }
        }
      }
    }
    .mid {
      grid-area: mid;
      display: flex;
      width: 64.01vw;
      background: var(--light);
      box-shadow: 0px 0px 40px 3px rgba(0, 0, 0, 0.08);
      margin-left: auto;
      margin-right: auto;
      margin-top: -10vw;

      h1 {
        font-size: 1.146vw;
        line-height: 1.146vw;
        font-weight: 700;
        color: var(--black);
        padding: 0;
      }
      h2 {
        font-size: 0.938vw;
        line-height: 1.146vw;
        font-weight: 400;
        color: var(--black-seven);
      }
      h3 {
        font-size: 0.938vw;
        line-height: 1.146vw;
        font-weight: 400;
        color: var(--black-eight);
      }
      .mid-left {
        width: 21.458vw;
        .img {
          width: 21.458vw;
          height: 21.458vw;
          display: flex;
          align-items: center;
        }
        .content {
          margin-left: 0.781vw;
          margin-top: 0.7vw;
          display: grid;
          grid-template-columns: auto;
          h2 {
            margin-bottom: 2.031vw;
          }
          h1 {
            margin-bottom: 1.979vw;
          }
        }
      }
      .mid-right {
        width: 42.552vw;
        display: flex;
        flex-direction: column;
        .mid-right-row {
          display: flex;
          box-shadow: 0px 0px 40px 3px rgba(0, 0, 0, 0.08);
          .img {
            width: 10.677vw;
            height: 10.677vw;
            display: flex;
            align-items: center;
            object-fit: cover;
          }
          .content {
            margin-left: 1.302vw;
            padding-bottom: 1.042vw;
            display: grid;
            grid-template-columns: auto;
            h2 {
              margin-top: 1.042vw;
              margin-bottom: 2.031vw;
            }
            h1 {
              margin-bottom: 1.979vw;
            }
          }

          &:nth-child(2) {
            margin-top: 0.16vw;
            display: flex;
          }
          &:nth-child(3) {
            margin-top: 0.16vw;
          }
        }
      }
    }
    .right {
      grid-area: right;
      display: flex;
      flex-direction: column;
      margin-top: 2.083vw;
      .right-page {
        width: 16.927vw;
        .img {
          width: 16.927vw;
          height: 12.708vw;
        }
        .content {
          display: grid;
          grid-template-areas:
            "category date"
            "title title";
            margin-top: 0.7vw;
          h2 {
            grid-area: category;
            font-weight: 400;
            color: var(--black-seven);
            margin-bottom: 0.26vw;
          }
          h3 {
            grid-area: date;
            font-weight: 400;
            color: var(--black-eight);
            text-align: right;
          }
          h1 {
            grid-area: title;
            font-weight: 700;
            color: var(--black);
            padding: 0;
          }
        }
        &:nth-child(2) {
          margin-top: 1.823vw;
        }
        &:nth-child(3) {
          margin-top: 1.823vw;
        }
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .wrapper {
    .fivthIpad {
      background: var(--second-bg);
      h1 {
        display: block;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      p {
        display: block;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 6.771vw;
      }
      .ipad-top {
        display: flex;
        width: 79.557vw;
        height: 32.031vw;
        background: var(--light);
        padding-top: 1.953vw;
        .ipad-top-holder {
          display: flex;
          .img {
            width: 32.422vw;
            height: 24.349vw;
            margin-left: 2.6vw;
          }
          .ipad-content {
            display: grid;
            grid-template-areas:
              "ipad-title ipad-title"
              "ipad-category ipad-date"
              "ipad-brief ipad-brief";
            margin-left: 1.953vw;
            grid-template-rows: 6vw 2.344vw 10.417vw;
            text-align: left;
            width: 38.021vw;
            gap: 1vw;
            h1 {
              grid-area: ipad-title;
              color: var(--black);
              font-size: 2.083vw;
              line-height: 2.865vw;
              font-weight: 600;
              display: block;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            h2 {
              grid-area: ipad-category;
              color: var(--black-seven);
              font-size: 1.693vw;
              line-height: 2.344vw;
              font-weight: 600;
            }
            h3 {
              grid-area: ipad-date;
              color: var(--black-seven);
              font-size: 1.693vw;
              line-height: 2.344vw;
              font-weight: 300;
            }
            p {
              grid-area: ipad-brief;
              color: var(--p-grey);
              font-size: 1.693vw;
              line-height: 2.083vw;
              font-weight: 500;
              height: 9.766vw;
            }
          }
        }
      }
      .bottom {
        display: flex;
        justify-content: space-around;
        margin-top: -2vw;
        h1 {
          font-size: 2.083vw;
          line-height: 2.865vw;
          font-weight: 600;
          color: var(--black);
        }
        h2 {
          font-size: 1.693vw;
          line-height: 2.344vw;
          font-weight: 600;
          color: var(--black-seven);
        }
        h3 {
          font-size: 1.693vw;
          line-height: 2.344vw;
          font-weight: 300;
          color: var(--black);
        }
        .left-column {
          display: flex;
          flex-direction: column;
          margin-left: 4.948vw;
          .ipad-left {
            width: 27.734vw;

            .img {
              width: 27.734vw;
              height: 27.734vw;
              display: flex;
              align-items: center;
              object-fit: cover;
            }
            .ipad-content {
              h2 {
                margin-bottom: 0.521vw;
              }
              h1 {
                margin-bottom: 0.781vw;
              }
            }
            &:nth-child(2) {
              margin-top: 4.557vw;
            }
          }
        }
        .right-column {
          display: flex;
          flex-direction: column;
          .rightsec {
            width: 63.021vw;
            display: flex;
            margin-top: 0.26vw;
            background: var(--light);
            box-shadow: 0px 0px 40px 3px rgba(0, 0, 0, 0.08);
            .img {
              width: 19.661vw;
              height: 19.661vw;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .ipad-content {
              width: 38.151vw;
              margin-left: 1.953vw;
              h2 {
                margin-top: 2.604vw;
                margin-bottom: 0.651vw;
              }
              h1 {
                margin-bottom: 0.651vw;
              }
            }
            &:nth-child(2) {
              margin-top: 0.26vw;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 414px) {
  .wrapper {
    .fivthIpad {
      padding-bottom: 10.667vw;
      padding-top: 6.933vw;
      .ipad-top {
        width: 94.667vw;
        height: 50vw;
        margin-left: auto;
        margin-right: auto;
        .ipad-top-holder {
          .img {
            width: 47.733vw;
            height: 36vw;
          }
          .ipad-content {
            width: 100%;
            height: 100%;
            display: grid;
            grid-template-areas:
              "top-category"
              "top-title"
              "top-brief"
              "top-date";
            grid-template-rows: 3.733vw 8vw 14.2vw 3.733vw;
            h2 {
              grid-area: top-category;
              font-size: 2.667vw;
              line-height: 3.733vw;
              font-weight: 600;
            }
            h3 {
              grid-area: top-date;
              font-size: 2.667vw;
              line-height: 3.733vw;
              font-weight: 600;
              margin-left: auto;
              margin-right: 1.333vw;
            }
            h1 {
              grid-area: top-title;
              font-size: 3.2vw;
              line-height: 4vw;
              font-weight: 600;
            }
            p {
              grid-area: top-brief;
              font-size: 2.933vw;
              line-height: 3.733vw;
              font-weight: 500;
              color: var(--p-mobile);
            }
          }
        }
      }
      .bottom {
        margin-top: -5vw;
        display: grid;
        grid-template-areas:
          "right-column"
          "left-column";
        h2 {
          grid-area: top-category;
          font-size: 2.667vw;
          line-height: 3.733vw;
          font-weight: 600;
        }
        h3 {
          grid-area: top-date;
          font-size: 2.667vw;
          line-height: 3.733vw;
          font-weight: 600;
        }
        h1 {
          grid-area: top-title;
          font-size: 3.2vw;
          line-height: 4vw;
          font-weight: 600;
        }
        p {
          grid-area: top-brief;
          font-size: 2.933vw;
          line-height: 3.733vw;
          font-weight: 500;
          color: var(--p-mobile);
        }
        .left-column {
          grid-area: left-column;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          margin-left: 0;
          margin-top: 5.333vw;

          .ipad-left {
            width: 49.867vw;
            .img {
              width: 49.867vw;
              height: 33.6vw;
            }
            .ipad-content {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              text-align: center;
              width: 41.867vw;
              padding-left: 4vw;
              h2 {
                margin-bottom: 0.8vw;
              }
              h1 {
                margin-bottom: 1.6vw;
              }
            }
            &:nth-child(2) {
              margin-top: 0;

              .ipad-content {
                margin-left: auto;
                margin-right: auto;
              }
            }
          }
        }
        .right-column {
          grid-area: right-column;
          margin-left: 3.5vw;
          .rightsec {
            width: 94.667vw;
            .img {
              width: 33.333vw;
              height: 33.333vw;
            }
            .ipad-content {
              width: 56vw;
              h2 {
                margin-top: 5.6vw;
                margin-bottom: 0.8vw;
              }
              h1 {
                margin-bottom: 1.6vw;
              }
            }
          }
        }
      }
    }
  }
}
</style>